import { CustomRouteOption } from '~/apps/routes/RoutesTypes'
import { suspend } from '~/apps/routes/utils'
import { LOGIN_PATH } from '~/redux-modules/preferences'
import ThrowError from '~/components/ThrowError'

const DownloadImDfmReportPage = suspend(
    () => import('@Builder/DownloadImDfmReportPage'),
)
const LoginPage = suspend(() => import('@User/LoginPage'))
const ForgetPasswordPage = suspend(() => import('@User/ForgetPasswordPage'))
const ResetPasswordPage = suspend(() => import('@User/ResetPasswordPage'))
const ExpiredBusinessAccountInvitationPage = suspend(
    () =>
        import(
            '../../consumer/pages/shared/ExpiredBusinessAccountInvitationPage'
        ),
)
const SignUpPage = suspend(() => import('@User/SignUpPage'))
const OverridesPage = suspend(
    () => import('../../consumer/pages/eng/OverridesPage'),
)
const PunchoutLandingPage = suspend(() => import('@User/PunchoutLandingPage'))
const VerifyEmailPage = suspend(
    () =>
        import('../../consumer/pages/User/LoginPage/LoginForm/VerifyEmailPage'),
)

const VerifyEmailAddressPage = suspend(
    () => import('@User/VerifyEmailAddressPage'),
)

/**
 * List of public(accessible without login) route configs to be used by react-router
 * When this config will be mapped to react-router <Route /> props each element will be wrapped with custom <PublicRoute /> component
 */
export const publicRoutes: CustomRouteOption[] = [
    {
        path: '/download-dfm-report/:qmrId/:view',
        element: <DownloadImDfmReportPage />,
    },
    {
        path: LOGIN_PATH,
        element: <LoginPage />,
        unAuthRoute: true,
    },
    {
        path: '/verifyEmail',
        element: <VerifyEmailPage />,
    },
    {
        path: '/verify-email',
        element: <VerifyEmailAddressPage />,
    },
    {
        path: '/forget-password',
        element: <ForgetPasswordPage />,
        unAuthRoute: true,
    },
    {
        path: '/reset-password/:token',
        element: <ResetPasswordPage />,
        unAuthRoute: true,
    },
    {
        path: '/expired-business-account-invitation',
        element: <ExpiredBusinessAccountInvitationPage />,
        unAuthRoute: true,
    },
    {
        path: '/signup',
        element: <SignUpPage />,
        unAuthRoute: true,
    },
    {
        path: '/app/overrides',
        element: <OverridesPage />,
    },
    {
        path: '/punchout-landing',
        element: <PunchoutLandingPage />,
    },
    {
        path: '/pages/error',
        element: <ThrowError />,
    },
]
